import {toFixedDate, toMoneyValue, toPercentValue} from "../../../../utils/reactFunctions";

export const tableConfig = (firstColumnName: string) => {
    return [
        {
            headTitle: firstColumnName,
            rowValue: "id",
        },
        {
            headTitle: 'ID ERP',
            rowValue: "erpOrderId",
        },
        {
            headTitle: 'ID SOURCE',
            rowValue: "originOrderId",
        },
        {
            headTitle: 'FECHA',
            rowValue: "orderDate",
            custom: toFixedDate,
        },
        {
            headTitle: 'ORIGEN',
            rowValue: "originSystemCode",
        },
        {
            headTitle: 'ID VENDEDOR',
            rowValue: "sellerId",
        },
        {
            headTitle: 'NOMBRE VENDEDOR',
            rowValue: "sellerName",
        },
        {
            headTitle: 'ID CLIENTE',
            rowValue: "clientId",
        },
        {
            headTitle: 'CLIENTE',
            rowValue: "clientName",
        },
        {
            headTitle: 'CANAL',
            rowValue: "clientChannel",
        },
        {
            headTitle: 'TOTAL NETO',
            rowValue: "totalNetPrice",
            custom: toMoneyValue
        },
        {
            headTitle: 'IVA + IMP INTERNO',
            rowValue: "totalTaxes",
            custom: toMoneyValue
        },
        {
            headTitle: 'PERCEPCIONES',
            rowValue: "totalPerceptions",
            custom: toMoneyValue
        },
        {
            headTitle: 'MONTO',
            rowValue: "total",
            custom: toMoneyValue
        },
        {
            headTitle: 'ESTADO',
            rowValue: "erpState",
        },
        {
            headTitle: 'N° FACTURA',
            rowValue: "invoiceId",
        },
        {
            headTitle: 'TIPO OPERACION AXUM',
            rowValue: "axumOperationType",
        },
    ];
};

export const detailConfig = (firstColumnName: string) => {
    return [
        {
            headTitle: firstColumnName,
            rowValue: "articleId",
        },
        {
            headTitle: 'ARTÍCULO',
            rowValue: "articleName",
        },
        {
            headTitle: 'BULTOS',
            rowValue: "bundles",
        },
        {
            headTitle: 'UNIDADES ADICIONALES',
            rowValue: "units",
        },
        {
            headTitle: 'PRECIO BRUTO',
            rowValue: "totalGrossPrice",
            custom: toMoneyValue
        },
        {
            headTitle: 'BONIFICACIONES',
            rowValue: "totalBonusAndDiscount",
            custom: toPercentValue
        },
        {
            headTitle: 'PRECIO NETO',
            rowValue: "totalNetPrice",
            custom: toMoneyValue
        },
        {
            headTitle: 'IMPUESTOS',
            rowValue: "totalTaxes",
            custom: toMoneyValue
        },
        {
            headTitle: 'PRECIO FINAL',
            rowValue: "totalFinalPrice",
            custom: toMoneyValue
        },
    ];
};
